// extracted by mini-css-extract-plugin
export default {"download-template":"GroupsTab_download-template__WrvbV","icon":"GroupsTab_icon__7L-89"};